import { TypeOf, yup } from '@guiker/shared-framework'

export const setEarlyTerminationSchema = yup.object({
  terminatesAt: yup.date().required(),
})

export type SetEarlyTerminationSchema = TypeOf<typeof setEarlyTerminationSchema>
